import React from 'react';


const Pixel = (props) => {
    return(
        <div className="pixel" style={{backgroundColor: props.color}}>
        </div>
    )
}

export default Pixel;